<template>
    <div id="pcm-my-project-view">
        <div class="row">
            <div class="col-xl-12" v-loading="loadingState.projectList">
                <el-table :data="projects.list" style="width: 100%" >
                    <el-table-column prop="id" label="Tên">
                        <template slot-scope="scope" >
                            <div class="d-flex">
                                <div class="pr-2">
                                        <avatar :username="scope.row.project.name" :size="45"></avatar>
                                    </div>
                                <div class="project-item-name">
                                    <span class="font-weight-bold">
                                        {{scope.row.project.name}}
                                    </span>
                                    <br>
                                    <span>{{ scope.row.project.description }}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="Ngày bắt đầu"  width="180">
                        <template slot-scope="scope">
                            <span>{{scope.row.project.start_date | formatDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Ngày kết thúc" width="180">
                        <template slot-scope="scope">
                            <span>{{scope.row.project.end_date | formatDate}}</span>
                            
                        </template>
                    </el-table-column>
                    
                </el-table>
            </div>
            
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import Avatar from 'vue-avatar'
import moment from 'moment'
import API_PROJECT_MEMBER from '@/utils/api/project_member'


export default {
    name: 'pcm-my-project-view',
    components: {
        Avatar
    },
    data() {
        return {
             loadingState: {
                projectList: false,
            },
             form: {
                filter: {
                    type: '',
                },
               
            },
             projects:{
                list: [],
            }
          
        }
    },
    created() {
        let self = this;
        this.$emit('activeMenu', 'project.index');
        self.loadData()
        
    },
    methods: {
        loadData(){
           let self = this
            self.loadingState.projectList = true
            API_PROJECT_MEMBER.getList(self.$axios, self.form.filter, function(data) {
               self.loadingState.projectList = false
                if (data.status) {
                    self.projects = data.data
                } else {
                    self.showMessage('error', data.error_message)
                }
            }, function(error) {
                self.loadingState.projectList = false
            })
        },
     
    }
}
</script>